import React, { useEffect } from "react";
import { Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import { useLoadingWithRefresh } from "./app/hooks/useLoadingWithRefresh";
import { useSelector } from "react-redux";
import { RootState } from "./app/store";
import { useNavigate, useLocation } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import routes from "./routes";
import { useClientSsoRevalidate } from "./app/hooks/useClientSsoRevalidate";
import {
  CLIENT_SSO_ENTRY_PATH,
  CLIENT_SSO_HOME_PATH,
  isClientSsoAllowedPath,
  isClientSsoUser,
} from "./constants/clientSso";

function App() {
  const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);
  const { loading } = useLoadingWithRefresh();
  const navigate = useNavigate();
  const location = useLocation();

  const [trendsOpen, setTrendsOpen] = React.useState<boolean>(false);
  const isAuthenticated = useSelector(
    (state: RootState) => state.user.userInfo
  );
  useClientSsoRevalidate();

  useEffect(() => {
    const publicRoutes = [
      "/",
      "/auth/login",
      "/auth/forgot-password",
      "/auth/reset-password",
      "/auth/accept-invitation",
      CLIENT_SSO_ENTRY_PATH,
    ];
    if (
      !publicRoutes.includes(location.pathname) &&
      !loading &&
      !isAuthenticated
    ) {
      if (isClientSsoAllowedPath(location.pathname)) {
        navigate(CLIENT_SSO_ENTRY_PATH, { replace: true });
        return;
      }
      navigate("/auth/login", { replace: true });
    }
  }, [loading, isAuthenticated, navigate, location.pathname]);

  useEffect(() => {
    if (
      !loading &&
      isAuthenticated &&
      isClientSsoUser(isAuthenticated.group) &&
      !isClientSsoAllowedPath(location.pathname)
    ) {
      navigate(CLIENT_SSO_HOME_PATH, { replace: true });
    }
  }, [loading, isAuthenticated, navigate, location.pathname]);

  useEffect(() => {
    if (trendsOpen === true && isSidebarOpen === false) {
      setIsSidebarOpen(true);
    }
  }, [trendsOpen]);

  useEffect(() => {
    if (trendsOpen === true && isSidebarOpen === false) {
      setTrendsOpen(false);
    }
  }, [isSidebarOpen]);

  return loading ? (
    <div className="flex">
      <div className="w-64 h-screen bg-gray-100 p-4">
        <Skeleton height="100%" width="100%" className="mb-4" />
      </div>
      <div className="flex-1 flex flex-col">
        <div className="h-24 p-4">
          <Skeleton height="100%" width="100%" />
        </div>
        <div className="h-full p-4">
          <Skeleton height="100%" width="100%" />
        </div>
      </div>
    </div>
  ) : (
    <>
      <ToastContainer />
      <Routes>
        {routes(isSidebarOpen, setIsSidebarOpen, trendsOpen, setTrendsOpen)}
      </Routes>
    </>
  );
}

export default App;
